import { Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, HostListener, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay, startWith } from 'rxjs/operators';
import productList from 'src/app/Models/Product/product_model';
import { categoriesList } from 'src/app/Models/Product/productsCategories_model';
import { AppStateService } from 'src/app/Services/AppState/app-state.service';
import Rutas from 'src/app/Models/Base/rutas';
import { Item } from 'src/app/Models/Product/product_modules.model';
import Storage from 'src/app/Models/Base/storage';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { getLocalStorage } from 'npx-arc-ui/utils';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { LayoutProductsComponent } from '../layout-products/layout-products.component';

interface HomeProductsState {
  products: productList[] | undefined;
  error: boolean;
}

interface HomeCategoriesState {
  categories: categoriesList[] | undefined;
  error: boolean;
}

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule
    , RouterModule
    , MatIconModule
    , NgxSkeletonLoaderModule
    , LayoutProductsComponent
  ]
})

export class DashboardComponent implements OnInit {

  allProducts = Rutas.PRODUCTS;
  allNews = this.News;
  urlNewsDashboard$: Observable<{
    success: boolean;
    url: string | null;
  }>;
  moduleDashboard$: Observable<{
    success: boolean,
    item: Item | null
  }>
  product$: Observable<HomeProductsState>;
  categories$?: Observable<HomeCategoriesState>;
  activeTab: 'recent' | 'modules' = 'recent';
  sectionIframehidden: boolean = false;
  IsSupport: boolean = false;
  private chatScriptUrl = 'https://widgets.defontana.com/chatbot/bundle.js';

  constructor(
    public appStateService: AppStateService, private elRef: ElementRef) {
    this.urlNewsDashboard$ = this.appStateService.CompanyServices.GetUrlEmbedNews();
    this.moduleDashboard$ = this.appStateService.ProductService.GetModuleERP();
    this.product$ = this.getRecentProducts();
    this.appStateService.dialog.closeAll();
  }

  private getRecentProducts(): Observable<HomeProductsState> {
    return this.appStateService.ProductService.GetProductsByCompanyAndUser().pipe(
      map(result => ({ products: result.productList || [], error: false })),
      startWith({ products: undefined, error: false }),
      catchError(() => of({ products: [], error: true })),
      shareReplay({ bufferSize: 1, refCount: true })
    );
  }

  selectTab(tab: 'recent' | 'modules'): void {
    this.activeTab = tab;
    if (tab === 'modules' && !this.categories$) {
      this.loadCategories();
    }
  }

  retryProducts(): void {
    if (this.activeTab === 'recent') {
      this.product$ = this.getRecentProducts();
    } else {
      this.loadCategories();
    }
  }

  private loadCategories(): void {
    this.categories$ = this.appStateService.ProductService.GetProductsByCategories().pipe(
      map(result => ({ categories: (result.categories || []).filter(category => category.products?.length), error: false })),
      startWith({ categories: undefined, error: false }),
      catchError(() => of({ categories: [], error: true })),
      shareReplay({ bufferSize: 1, refCount: true })
    );
  }

  @HostListener('window:scroll', ['$event'])
  onScroll(event: Event): void {
    // Get the div element by its ID
    const trackedDiv = this.elRef.nativeElement.querySelector('#tracked-beamer');
    // Get the div's position relative to the viewport
    const rect = trackedDiv?.getBoundingClientRect();

    // Example: Check if the top of the div is visible within the viewport
    if (rect?.top >= 0 && rect?.top <= window.innerHeight) {
      this.sectionIframehidden = true;
    }
  }

  ngOnInit(): void {
    if (!!this.appStateService.returnProduct.length) {
      this.appStateService.ProductService.setErpLogin(
        this.appStateService.returnProduct,
        false,
        ''
      );
    }
    
    this.IsSupport = getLocalStorage(Storage.SUPPORT_LOGIN)?.data === '1' ? true : false;
    if (this.IsSupport) {
      this.loadScript(this.chatScriptUrl);
    }
  }

  /**
   * @description Permite subir el scroll al top al momento de cargar el iframe de noticias
   * @param evt booleano de respuesta proveniente del componente iframe
   */
  onLoad(evt: boolean) {
    let scrollToTop = window.setInterval(() => {
      let pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 20);
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 16);
  }

  get calc(): string {
    return this.appStateService.isMobile ? '100%' : '400px'
  }

  get lastAccess(): string {
    return this.appStateService.LastAccess;
  }

  get News(): Array<{
    title: string;
    text: string;
    href: string;
    img: string;
  }> {
    return [
      {
        title: 'Conoce a Defontana',
        text: 'Somos una plataforma de soluciones para empresas de todo tipo y tamaño para la gestión. Conócenos aquí.',
        href: 'https://www.defontana.com/cl/nosotros',
        img: 'assets/media/svg/Conoceadefontana.svg',
      },
      {
        title: 'Capacítate con Defontana',
        text: 'Encuentra diversos cursos para seguir capacitándote y crecer profesionalmente. Obtén certificaciones y mucho más.',
        href: 'https://academiadigital.defontana.com/',
        img: 'assets/media/svg/capacitatecondefontana.svg',
      },
      {
        title: 'Centro de ayuda',
        text: 'Espacio de ayuda para los usuarios de los sistemas Defontana. Revisa artículos de ayuda para el mejor uso del sistema.',
        href: 'https://intercom.help/defontanaerp/es/',
        img: 'assets/media/svg/centrodeayuda.svg',
      },
    ];
  }

  onActualizar = () => this.appStateService.CompanyServices.GetList().subscribe();

  adminUsers() {
    this.appStateService.router.navigateByUrl(Rutas.ADMINISTRATION);
  }

  onSelect() {
    this.appStateService.onSelectProduct('31', true, 'ecosistema-digital');
  }

  private loadedScripts: { [url: string]: boolean } = {};

  private loadScript(url: string): void {
    // Evitar cargarlo dos veces
    
    if (document.querySelector(`script[src="${url}"]`)) {
      return;
    }

    const script = document.createElement('script');
    script.src = url;
    script.async = true;
    script.defer = true;

    script.onload = () => {
      console.log('✅ Chat widget cargado correctamente');
    };

    script.onerror = () => {
      console.error(`❌ Error al cargar el script: ${url}`);
    };

    document.body.appendChild(script);
  }


}
